import React from "react";
import { Icon } from "./icon";
import { Pressable } from "./pressable";
import { stylex } from "./stylex";
import { cssVariables } from "./css_variables";

interface CloseButtonProps {
  onPress?: () => void;
  testID?: string;
}

export function CloseButton(props: CloseButtonProps) {
  const { onPress = () => {} } = props;

  return (
    <Pressable
      onPress={onPress}
      style={({ hovered }) => styles("base", hovered && "hovered")}
    >
      <Icon name="x" color={cssVariables.textColorPrimary} />
    </Pressable>
  );
}

const styles = stylex.create({
  base: {
    padding: 8,
    borderRadius: 999,
  },
  hovered: {
    backgroundColor: "rgba(0, 0, 0, 0.05)",
  },
});
